import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getSummaryImportFiltersSuccess,
  getSummaryImportFiltersError,
  getSummaryImportSuccess,
  getSummaryImportError
} from './actions';
import * as url from '../../helpers/url_helper';
import { SummaryImportTypes } from './actionTypes';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchSI = () => {
    controller.abort(); 
    controller = new AbortController(); 
    signal = controller.signal; 
  };

  const FormatDynamicFilter = (dynamicFilter:any, newClientId:any) => {
    const clientIdRegex = /clientId: "\d+"/;
    if (clientIdRegex.test(dynamicFilter)) {
      return dynamicFilter.replace(clientIdRegex, `clientId: "${newClientId}"`);
    } else {
      return `${dynamicFilter}, clientId: "${newClientId}"`;
    }
  };

export const fetchListSummaryImport = async ({payload}: any) => {
    const { from, to, order } = payload.filters;
    let { dynamicFilter } = payload.filters;
    const { sizePerPage, page } = payload.pagination;


    const path = url.API_URL;

    let user;
    
    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    if(user?.ROL_ID != 19){
      dynamicFilter = FormatDynamicFilter(dynamicFilter,user.EMPRESA_ID)
    }

    const query = `query {
        GetSummaryImportControl(
        SummaryImportControl: {
          userId: ${user.id || ''},
        },
        filters: {
          initial_date: "${from || ''}",
          final_date:"${to ? to + ' 23:59:59' : ''}",
          order : "${order}",
          ${dynamicFilter}
        },
        Pagination:{
          sizePage:${sizePerPage}, 
          actualPage:${page}
        }){
            CountItems
            listData {
               status
                resultXML
                message
                text
                Number
                entity
                identificator
                clientId
                taskId
                createdAt
              iTask{
                descripcion
              }
            }

        }
    }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
        signal
    }).then((res) => res.json());

    return response.data.GetSummaryImportControl;
};

export const SummaryImportFilters = async (payload: { from?: string; to?: string } = {}) => {
    const path = url.API_URL;
    let user;
    
    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
        GetSummaryImportControlFilters(
          rolId: "${user.ROL_ID || ""}",
          userId: ${user.id || 0},
          initial_date: "${payload.from || ''}",
          final_date: "${payload.to || ''}"
        ){
            filterItems {
                text
                dataField
                showInFilters
                data {
                    id
                    name
                }
            } 

        }
    }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
        signal
    }).then((res) => res.json());

    return response.data.GetSummaryImportControlFilters;
};

function* getSummaryImportSaga(payload: any) {
  try {
    const response: Promise<any> = yield call(fetchListSummaryImport,payload);
    if (response) {
      yield put(getSummaryImportSuccess(response));
    }
  } catch (error) {
    yield put(getSummaryImportError(error));
  }
}

function* getSummaryImportFiltersSaga(action: any) {
  try {
    const response: Promise<any> = yield call(SummaryImportFilters, action?.payload || {});
    if (response) {
      yield put(getSummaryImportFiltersSuccess(response));
    }
  } catch (error) {
    yield put(getSummaryImportFiltersError(error));
  }
}

function* SummaryImportSaga() {
  yield takeLatest(SummaryImportTypes.GET_FILTER_LIST, getSummaryImportSaga);
  yield takeLatest(SummaryImportTypes.GET_FILTERS,getSummaryImportFiltersSaga,
  );
}

export default SummaryImportSaga;
